import {Component, ViewChild}         from '@angular/core';
import {ApMachinesEditComponent}      from '../../entry-components/ap-basedata-entry-components/ap-machines-edit.component';
import {ApDriversEditComponent}       from '../../entry-components/ap-basedata-entry-components/ap-drivers-edit.component';
import {ApInstrumentsEditComponent}   from '../../entry-components/ap-basedata-entry-components/ap-instruments-edit.component';
import {ApMachinesComponent}          from './machines/ap-machines.component';
import {ApInstrumentsComponent}       from './instruments/ap-instruments.component';
import {ApDriversComponent}           from './drivers/ap-drivers.component';
import {ApSectionHeaderGridComponent} from '../../ap-section-header/components/ap-section-header-grid/ap-section-header-grid.component';
import {FormStore}                    from '../../stores/layout/form.store';
import {ApTerminalsOverviewComponent} from './terminals/ap-terminals.overview.component';

/**
 * Enumeration of all ressource tabs
 */
export enum RessourceTabs {
  Machines = 0,
  Instrument = 1,
  Drivers = 2,
  Terminals = 3
}

/**
 * Component for docu ressources overview
 */
@Component({
  selector: 'ap-docu-ressources',
  templateUrl: 'ap-docu-ressources.component.html'
})

/**
 * Component for docu ressources overview
 */
export class ApDocuRessourcesComponent {

  @ViewChild(ApMachinesComponent, {static: false})
  public machineComonent: ApMachinesComponent;

  @ViewChild(ApInstrumentsComponent, {static: false})
  public instrumentsComponent: ApInstrumentsComponent;

  @ViewChild(ApDriversComponent, {static: false})
  public driversComponent: ApDriversComponent;

  @ViewChild(ApTerminalsOverviewComponent, {static: false})
  public terminalsComponent: ApTerminalsOverviewComponent;

  @ViewChild(ApSectionHeaderGridComponent, {static: false})
  private headerComponent: ApSectionHeaderGridComponent;

  public selectedTab: RessourceTabs = RessourceTabs.Machines;

  constructor(private formStore: FormStore) {
  }

  /**
   * Handler for selectedTab changed.
   * Determins the selected tab for proper new-handling.
   */
  public selectTab(e): void {
    this.headerComponent.reset();
    switch (this.selectedTab) {
      case RessourceTabs.Machines:
        this.machineComonent?.dynComponent?.dynGrid?.filterGrid('');
        break;
      case RessourceTabs.Instrument:
        this.instrumentsComponent?.dynComponent?.dynGrid?.filterGrid('');
        break;
      case RessourceTabs.Drivers:
        this.driversComponent?.dynComponent?.dynGrid?.filterGrid('');
        break;
      case RessourceTabs.Terminals:
        this.terminalsComponent?.dynComponent?.dynGrid?.filterGrid('');
        break;
    }
    this.selectedTab = e.index;
  }

  /**
   * Search in ressources
   */
  public searchIn(value: string): void {
    /*
     * Filters the grid and forces a refresh of the grid.
     * This is necessary because the grid is embedded within a Tab.
     */
    switch (this.selectedTab) {
      case RessourceTabs.Machines:
        this.machineComonent?.dynComponent?.dynGrid?.filterGrid(value);
        break;
      case RessourceTabs.Instrument:
        this.instrumentsComponent?.dynComponent?.dynGrid?.filterGrid(value);
        break;
      case RessourceTabs.Drivers:
        this.driversComponent?.dynComponent?.dynGrid?.filterGrid(value);
        break;
      case RessourceTabs.Terminals:
        this.terminalsComponent?.dynComponent?.dynGrid?.filterGrid(value);
        break;
    }
  }

  /**
   * Handler for creating a new ressource.
   * Depending on the selected tab the corresponding edit-form opens.
   */
  public createNew(): void {

    let docuComponent: any;
    switch (this.selectedTab) {
      case RessourceTabs.Machines:
        docuComponent = ApMachinesEditComponent;
        break;
      case RessourceTabs.Instrument:
        docuComponent = ApInstrumentsEditComponent;
        break;
      case RessourceTabs.Drivers:
        docuComponent = ApDriversEditComponent;
        break;
    }
    if (!docuComponent) {
      return;
    }
    this.formStore.openForm({component: docuComponent, data: null});
  }

  isCreateNewAllowed(): boolean {
    return this.selectedTab !== RessourceTabs.Terminals;
  }
}
